const steps = [
    {id: 1, title: 'Purchase', name: 'purchase'},
    {id: 2, title: 'Pre-Authorization', name: 'preauth'},
    {id: 3, title: 'Pre-Authorization Completion', name: 'preauth_comp'},
    {id: 4, title: 'Force Post', name: 'force_post'},
    {id: 5, title: 'Purchase Correction', name: 'purchase_corr'},
    {id: 6, title: 'Refund', name: 'refund'},
    {id: 7, title: 'Independent Refund', name: 'ind_refund'},
    {id: 8, title: 'Card Verification with AVS and CVD', name: 'card_ver'},
    {id: 9, title: 'Batch Close', name: 'batch_close'},
    {id: 10, title: 'Open Totals', name: 'open_totals'}
]

export default steps